import { useMemo, useState } from 'react';

import { EuBankStatus } from '@/components/Shared/constants/banks-statuses';
import { BANKS_ICONS_NAMES, DictTypes } from '@/constants';
import { useWindowSize } from '@/hooks/useWindowSize';
import { useAppSelector } from '@/store';

import type { TEurasV1BankOffer } from '../../../types/euras-v1.types';
import useAdditionalHelpers from './useAdditionalHelpers';

type IProps = {
  bankOffer: TEurasV1BankOffer;
  hasOfferedResponse?: boolean;
};

const blueColoredStatuses = [
  EuBankStatus.WaitingOfFinancing,
  EuBankStatus.FinancedPledgeMissing,
  EuBankStatus.FinancedWaitingForModificationBeforePledge,
  EuBankStatus.WaitingForUploadFiles,
  EuBankStatus.OnRework
];

const useFormulateOfferItem = ({
  bankOffer: initialBankOffer,
  hasOfferedResponse
}: IProps) => {
  const [windowWidth] = useWindowSize();
  const isMobile = windowWidth <= 860;

  const { dicts } = useAppSelector((state) => state.dict);
  const { orderApp } = useAppSelector((state) => state.newOrder);

  const [offerDetailsModal, setOfferDetailsModal] = useState<boolean | string>(
    false
  );

  const bankOffer: TEurasV1BankOffer = useMemo(() => {
    const product =
      orderApp?.productInfo.product.stocksBonds?.find(
        (prod) => prod.bank_name === initialBankOffer.bank.name
      )?.label || 'Стандарт';

    return {
      ...initialBankOffer,
      product
    };
  }, [initialBankOffer, orderApp?.productInfo.product.stocksBonds]);

  const { additionalProducts, getDescription } = useAdditionalHelpers({
    bankOffer,
    offerDetailsModal
  });

  const bankDict =
    dicts?.[DictTypes.Banks]?.getBy.name[initialBankOffer.bank.name];
  const bankIconName =
    BANKS_ICONS_NAMES[
      initialBankOffer.bank.name as keyof typeof BANKS_ICONS_NAMES
    ];
  const isCurrentResponseOffered =
    hasOfferedResponse && initialBankOffer.isOffered;

  return {
    bankOffer,
    additionalProducts,
    getDescription,
    headerIcon: bankDict?.icon || bankIconName?.icon,
    headerTitle: bankDict?.fullname || bankIconName?.name,
    isBlueColoredStatus: blueColoredStatuses.includes(
      initialBankOffer.status.code as EuBankStatus
    ),
    isCurrentResponseOffered,
    isMobile,
    offerDetailsModal,
    setOfferDetailsModal
  };
};

export default useFormulateOfferItem;
